// --------------------- Import Globais ---------------------
import { useEffect, useState } from "react";
// --------------------- Import Antd-Design ---------------------
import { Modal } from "antd";
import { useNavigate } from "react-router-dom";
// --------------------- Import Hooks ---------------------
import { useExcluirInteresse } from "../hooks/useExcluirInteresse";
// --------------------- Import Styles ---------------------
import { Title } from "../../ViewGerenciarPostagens/styles";
// --------------------- Import Uteis ---------------------
import { useError } from "../../../uteis/mensagens/useError";
import { useSuccess } from "../../../uteis/mensagens/useSuccess";

export default function ModalExcluir({
  isModalOpen,
  handleFechar,
  fecharModal,
  interesseId,
  buscar,
}: any) {
  // Chamada da função para atualizar
  const { excluir, isLoading, error, success, resetError, resetSuccess } =
    useExcluirInteresse();

  // Exibe a Mensagem de  Erro
  const { showError, contextHolder: errorContextHolder } = useError();

  // Exibe a Mensagem de  Erro
  const { showSuccess, contextHolder: successContextHolder } = useSuccess();

  // Estado para controlar se o erro já foi exibido
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  // Estado para controlar se o sucesso já foi exibido
  const [successDisplayed, setSuccessDisplayed] = useState(false);

  useEffect(() => {
    if (success && !successDisplayed) {
      showSuccess(success);
      setSuccessDisplayed(true);
      handleFechar();
      fecharModal();
      // Limpa sucesso após 3 segundos
      setTimeout(() => {
        setSuccessDisplayed(false);
        resetSuccess();
        buscar();
      }, 2000);
    }

    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);

      // Limpa erro após 3 segundos
      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
  }, [
    isModalOpen,
    success,
    error,
    showSuccess,
    showError,
    successDisplayed,
    errorDisplayed,
    resetError,
    resetSuccess,
    handleFechar,
    buscar,
  ]);

  return (
    <>
      <Modal
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Excluir"
        onOk={() => excluir(interesseId)}
        confirmLoading={isLoading}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          }, // Botão "Ativar" com fundo verde
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          }, // Botão "Cancelar" com fundo vermelho
        }}
      >
        {
          <>
            <>{errorContextHolder}</>
            <>{successContextHolder}</>
            <Title>Tem certeza que deseja excluir?</Title>
            <p
              style={{
                color: "#555",
                fontSize: "14px",
                maxWidth: "300px",
                margin: "0 auto 20px",
              }}
            >
              Essa ação é irreversível. Depois, será necessário criar um novo
              período se precisar.
            </p>
          </>
        }
      </Modal>
    </>
  );
}
